import { defineMessages } from 'react-intl-next';

export default defineMessages({
	fileCloseIconLabel: {
		id: 'ai-mate.chat-input.file-close-icon-label',
		defaultMessage: 'Remove file',
		description: 'Label for the remove file icon',
	},
	fileErrorIconLabel: {
		id: 'ai-mate.chat-input.file-error-icon-label',
		defaultMessage: 'Error loading file',
		description: 'Label for the error icon',
	},
} as const);
